import React, { useContext } from 'react';
import { ToastContext } from '../context/ToastContext';

export const useNotification = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useNotification must be used within a ToastProvider');
    }
    return context;
}; 